export const TODAY_GIFT_SLICE_NAME = 'todayGift';
export const TODAY_GIFT_TAB_ID = 'today-gift';
